export type CommissionKpiResult = "BELOW" | "REACHED" | "EXCEEDED";
export type CommissionStatus = "LOCKED" | "UNLOCKED_FOR_EDIT";

export const commissionKpiResultTrans: Record<
  CommissionKpiResult,
  { label: string; color: string; bgcolor: string }
> = {
  BELOW: { label: "Chưa đạt", color: "#b42318", bgcolor: "#fef3f2" },
  REACHED: { label: "Đạt", color: "#175cd3", bgcolor: "#eff8ff" },
  EXCEEDED: { label: "Vượt", color: "#027a48", bgcolor: "#d1fadf" },
};

export interface CommissionRow {
  commissionId?: number;
  staffId: number;
  staffName: string;
  baseSalary: number;
  revenueCollected: number;
  targetRevenue: number;
  rateBelowKpi: number;
  rateReachKpi: number;
  rateExceedKpi: number;
  kpiResult: CommissionKpiResult;
  personalCommissionAmount: number;
  hasKpiConfig: boolean;
  teamRevenueCollected: number;
  teamTargetRevenue: number;
  teamBonusRate: number;
  teamCommissionAmount: number;
  totalIncomeAmount: number;
  status: CommissionStatus;
  lockedAt?: number;
  lockedBy?: string;
  lastUnlockNote?: string;
  lastUnlockAt?: number;
  lastUnlockBy?: string;
}

export interface CommissionMonthlyData {
  isLocked: boolean;
  isUnlockedForEdit: boolean;
  rows: CommissionRow[];
  onlyMine: boolean;
}

export interface CommissionRevenueDetail {
  id: number;
  content: string;
  amount: number;
  preTaxAmount?: number;
  // Phần bị trừ khỏi số đã thu để ra "tính vào hoa hồng"; partnerPart chỉ có khi người xem là admin / chính sale đó
  vatPart?: number;
  partnerPart?: number;
  collectedDate: string;
  order: {
    id: number;
    code: string;
    opportunity?: {
      code: string;
      name: string;
    } | null;
    customer: {
      id: number;
      name: string;
    };
  };
}
